import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Enactment extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="enactment" className="a-breadcrumbs">พระราชบัญญัติสหกรณ์ / กฎกระทรวง</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>พระราชบัญญัติสหกรณ์ / กฎกระทรวง</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <a href="Form/Enactment/3.2563.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>พระราชบัญญัติสหกรณ์ (ฉบับที่ 3) พ.ศ. 2562</a><br />
                <br/>
                <a href="Form/Enactment/2.2553.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>พระราชบัญญัติสหกรณ์ (ฉบับที่ 2) พ.ศ. 2553</a><br />
                <br />
                <a href="Form/Enactment/1.2542.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>พระราชบัญญัติสหกรณ์  (ฉบับที่ 1) พ.ศ. 2542</a><br />
                <br />
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Enactment;
